import { MutationTree } from 'vuex';
import { TourState, Step } from './state';

const mutations: MutationTree<TourState> = {
  START_TOUR(state, steps: Step[]) {
    state.steps = steps;
    state.numberOfSteps = steps.length;
    if (state.numberOfSteps > 1) {
      state.hasNextStep = true;
    }
    state.currentStep = 0;
    state.isActive = true;
  },
  NEXT_STEP(state) {
    state.currentStep += 1;
  },
  PREVIOUS_STEP(state) {
    state.currentStep -= 1;
  },
  FINISH_TOUR(state) {
    state.isActive = false;
    state.currentStep = -1;
    state.steps = [];
    state.intervalId = null;
    state.hasNextStep = false;
    state.hasPreviousStep = false;
    state.numberOfSteps = 0;
  },
  SET_INTERVAL_ID(state, intervalId) {
    state.intervalId = intervalId;
  },
};

export default mutations;
